import { Controller } from "@hotwired/stimulus";
import mapboxgl from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { stringify, parse } from "wellknown";

export default class extends Controller {
  static targets = ["map", "input"];
  static values = {
    bounds: Array,
  };

  connect() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXJ3aWxsaWhvZyIsImEiOiJjbDI5YzRwZzkwMnNwM2NvNGY4aHh4eWR2In0.W4Eu3eTXf7XRC0e5K47zLw";

    this.listen();
  }

  listen() {
    const observer = new IntersectionObserver((entries) => {
      // Map already initialized so don't do it again
      if (this.map !== undefined) {
        return;
      }

      if (entries[0].isIntersecting) {
        this.initMap();
        this.initDraw();
      }
    });

    observer.observe(this.mapTarget);
  }

  initMap() {
    const params = {
      container: this.mapTarget,
      style: "mapbox://styles/mapbox/outdoors-v11",
      attributionControl: false,
      logoPosition: "bottom-right",
      bounds: this.boundsValue,
    };

    const map = new mapboxgl.Map(params);
    map.addControl(new mapboxgl.NavigationControl(), "top-right");
    map.addControl(
      new mapboxgl.GeolocateControl({
        showUserLocation: false,
      }),
      "top-right"
    );
    this.map = map;
  }

  initDraw() {
    const initialValue = this.inputTarget.value;

    const draw = new MapboxDraw({
      displayControlsDefault: false,
      // Select which mapbox-gl-draw control buttons to add to the map.
      controls: {
        polygon: true,
        trash: true,
      },
      // Set mapbox-gl-draw to draw by default.
      // The user does not have to click the polygon control button first.
      defaultMode: "draw_polygon",
    });
    this.map.addControl(draw, "top-left");

    this.map.on("draw.update", this.updateFormInput.bind(this));
    this.map.on("draw.create", this.updateFormInput.bind(this));
    this.map.on("draw.delete", this.deleteGeometry.bind(this));

    if (initialValue) {
      const geoJson = parse(initialValue);
      const ids = draw.add(geoJson);

      draw.changeMode("direct_select", {
        featureId: ids[0],
      });
    }
  }

  updateFormInput(event) {
    const firstFeature = event.features[0];

    if (!firstFeature) {
      this.inputTarget.value = "";
      return;
    }

    const geometry = firstFeature.geometry;
    const wkt = stringify(geometry);

    this.inputTarget.value = wkt;
  }

  deleteGeometry() {
    this.inputTarget.value = "";
  }
}
